import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * 
 * @param {Object} params 
 */
export function getUserList(data) {
  return fetch({
    url: '/auth/subPlatform/user/list',
    method: 'POST',
    data
  })
}


/**
 * 获取授权应用
 * @param {} params 
 */
export function getAppTypeList() {
  return fetch({
    url: '/auth/subPlatform/user/appTypeList',
    method: 'GET'
  })
}


/**
 * 获取授权角色
 * @param {Object} data 
 */
export function getRoleSimpleList(data) {
  return fetch({
    url: '/auth/role/getRoleByAppCodeList',
    method: 'POST',
    data
  })
}


/**
 * 获取电梯树形
 * @param {Object} params 
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * 获取单位列表
 * @param {Object} params 
 */
export function getUnitSimpleList(params) {
  return fetch({
    url: '/auth/unit/simpleList',
    method: 'GET',
    params
  })
}


/**
 * 获取部门列表
 * @param {Object} params 
 */
export function getDepartmentSimpleList(params) {
  return fetch({
    url: '/auth/department/simpleList',
    method: 'GET',
    params
  })
}


/**
 * 保存用户
 * @param {Object} data 
 */
export function saveUser(data) {
  return fetch({
    url: '/auth/subPlatform/user/saveUser',
    method: 'POST',
    data
  })
}


/**
 * 获取用户详情
 * @param {Object} params 
 */
export function getUserDetail(params) {
  return fetch({
    url: '/auth/subPlatform/user/userDetail',
    method: 'GET',
    params
  })
}


/**
 * 删除用户
 * @param {Object} data 
 */
export function deleteUser(data) {
  return fetch({
    url: '/auth/subPlatform/user/userDelete',
    method: 'POST',
    data
  })
}


/**
 * 导出用户列表
 * @param {Object} data 
 */
export function exportUserList(data) {
  return formAxios({
    url: '/auth/subPlatform/user/exportUserList',
    method: 'POST',
    data
  })
}


/**
 * 重置密码
 * @param {Object} params 
 */
export function restPassword(params) {
  return fetch({
    url: '/auth/subPlatform/user/restPassword',
    method: 'GET',
    params
  })
}


/**
 * 修改密码
 * @param {Object} data 
 */
export function userChangePassword(data) {
  return fetch({
    url: '/auth/subPlatform/user/userChangePassword',
    method: 'POST',
    data
  })
}


/**
 * 修改状态
 * @param {Object} data 
 */
export function userChangeStatus(data) {
  return fetch({
    url: '/auth/subPlatform/user/userChangeStatus',
    method: 'POST',
    data
  })
}



/**
 * 获取用户单位信息
 * @param {Object} data 
 */
export function getUnitInfoByUser() {
  return fetch({
    url: '/auth/subPlatform/user/getUnitInfoByUser',
    method: 'GET'
  })
}




// WEBPACK FOOTER //
// ./src/api/UserManagement/index.js